import { type UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { type CreateInvitationFormSchemaValues } from 'src/features/userManagement/api/useCreateInvitation';
import CommonFormFields from 'src/features/userManagement/components/forms/CommonFormFields';
import { userManagementMessages } from 'src/features/userManagement/utils';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Input } from 'src/registry/ui/Input';

interface InvitationFormProps {
    form: UseFormReturn<CreateInvitationFormSchemaValues>;
    onSubmit: () => void;
}

function InvitationForm({ form, onSubmit }: InvitationFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} variant="dialog" onSubmit={form.handleSubmit(onSubmit)}>
            <CommonFormFields<CreateInvitationFormSchemaValues>
                control={form.control}
                fieldNames={{
                    role: 'role',
                    validator_type: 'validator_allowed_validation',
                    validator_pricing_plan: 'validator_allowed_pricing_plan',
                }}
            >
                <FormField
                    control={form.control}
                    name="email"
                    render={({ field }) => (
                        <FormItem variant="dialog">
                            <FormLabel variant="dialog" required>
                                {formatMessage(userManagementMessages.email)}
                            </FormLabel>
                            <FormControlStack className="mr-3">
                                <FormControl>
                                    <Input type="text" placeholder="user@smartpark.com" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormControlStack>
                        </FormItem>
                    )}
                />
            </CommonFormFields>
        </Form>
    );
}

export { InvitationForm };
